import React from 'react'
import './report_title.css'
export default function ReportTitle() {
    return (
        <div className='report-title'>
            Report and Result
        </div>
    )
}
